export default {
  // 页面标题
  title: "推送统计",
  
  // 搜索表单
  searchForm: {
    pushTime: "推送时间",
    pushTimePlaceholder: "请选择时间范围",
    memberAccount: "推送会员",
    memberAccountPlaceholder: "请输入",
    pushType: "推送类型",
    pushTypePlaceholder: "请选择",
    search: "查询",
    reset: "重置"
  },
  
  // 表格列标题
  table: {
    memberAccount: "推送会员",
    pushType: "推送类型",
    subPushType: "子类型",
    pushTitle: "推送标题",
    pushContent: "推送内容",
    pushTime: "推送时间",
    status: "状态",
    createTime: "创建时间"
  },
  
  // 字段
  pushName: "消息名称",
  pushType: "推送类型",
  subPushType: "子类型",
  pushTime: "发送时间",
  memberType: "会员类型",
  memberTypePlaceholder: "请选择",
  createTime: "操作时间",
  createUserName: "操作人",
  sendUserCount: "发送用户量",
  pushSuccessToFailed: "推送总量/到达量",
  pushOpenCount: "推送打开量",
  pushOpenRate: "推送打开率",
  pleaseEnter: "请输入"
};
